import type { ShortDocument, YscDocument } from '@yescapa-dev/ysc-api-js/legacy'

export const everyDocumentIsValidated = (documents: (ShortDocument | YscDocument)[]) => !!documents.length && documents.every(documentIsValidated)
